import { __decorate } from "tslib";
import { Component } from "vue-property-decorator";
import LvCheckbox from "../checkbox/LvCheckbox.vue";
export const COMPONENT_NAME = "LvSwitch";
let LvSwitch = class LvSwitch extends LvCheckbox {
};
LvSwitch = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvSwitch);
export default LvSwitch;
//# sourceMappingURL=script.js.map